import { render } from "./approveInfo.vue?vue&type=template&id=6f34b75a&scoped=true&ts=true"
import script from "./approveInfo.vue?vue&type=script&lang=ts"
export * from "./approveInfo.vue?vue&type=script&lang=ts"

import "./approveInfo.vue?vue&type=style&index=0&id=6f34b75a&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f34b75a"]])

export default __exports__